import React from 'react';
import { ReactComponent as BannedIcon } from '../images/kickbadges/banned.svg';
import { ReactComponent as UnBannedIcon } from '../images/kickbadges/unbanned.svg';
import { ReactComponent as TimeoutIcon } from '../images/kickbadges/timeout.svg';
import { ReactComponent as TrashIcon } from '../images/kickbadges/kick-trash-icon.svg';
import { badgeMap, ICON_BADGE_TYPES } from './badges';

/**
 * The moderation panel for one chatter.
 *
 * user           { id, username, badges, isBanned, isTimedOut }
 * canBan         the viewer granted moderation:ban (timeout/ban/unban)
 * canDelete      the viewer granted moderation:chat_message:manage
 * lastMessageId  the user's newest deletable message, or null (disables "Delete Last Message")
 * enableUrl      the moderation login, offered when either scope is missing
 * onAction(action, userId, messageId, durationMinutes)
 */
const KickUserPanel = ({ user, canBan, canDelete, lastMessageId, enableUrl, onAction, onClose }) => (
  <div className="user-overview-panel">
    {/* Header with username and close button */}
    <div className="user-overview-header">
      <div className="user-overview-actions">
        {/* Render badges */}
        {user.badges?.map((badge, i) => {
          if (!badge.type) return null;
          if (ICON_BADGE_TYPES.includes(badge.type)) {
            return React.cloneElement(badgeMap[badge.type], { key: i, title: badge.text });
          }
          return null;
        })}
        <strong
          className="user-name"
          // style={{ color: user.color}}
        >
          {user.username}
        </strong>
      </div>

      <button
        onClick={onClose}
        className="user-overview-panel-close"
        title="Close"
      >
        ✕
      </button>
    </div>

    {/* Moderation Actions */}
    <div className="moderation-actions">
      {canDelete && (
        <button
          onClick={() => onAction('delete', user.id, lastMessageId)}
          className="moderation-actions-btn delete"
          disabled={!lastMessageId}
          title={lastMessageId ? 'Delete their most recent message' : 'No messages to delete'}
        >
          <TrashIcon viewBox="0 0 20 20" style={{ width: 18, height: 18, marginRight: 4}} /> Delete Last Message
        </button>
      )}

      {/* Timeout/Untimeout section */}
      {!canBan ? null : user.isTimedOut ? (
        <button
          onClick={() => onAction('untimeout', user.id, null)}
          className="moderation-actions-btn untimeout"
        >
          <UnBannedIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 4}} /> Remove Timeout
        </button>
      ) : (
        <div className="timeout-actions">
          <button
            onClick={() => onAction('timeout', user.id, null, 10)}
            className="moderation-actions-btn timeout"
          >
            <TimeoutIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 4}} /> Timeout 10m
          </button>
          <button
            onClick={() => onAction('timeout', user.id, null, 60)}
            className="moderation-actions-btn timeout"
          >
            <TimeoutIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 4}} /> Timeout 1h
          </button>
        </div>
      )}

      {/* Ban/Unban button */}
      {!canBan ? null : user.isBanned ? (
        <button
          onClick={() => onAction('unban', user.id, null)}
          className="moderation-actions-btn unban"
        >
          <UnBannedIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 4}} /> Unban User
        </button>
      ) : (
        <button
          onClick={() => onAction('ban', user.id, null)}
          className="moderation-actions-btn ban"
        >
          <BannedIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 4}} /> Ban User
        </button>
      )}

      {/* Moderation scopes are opt-in: offer them to moderators whose login doesn't have them */}
      {(!canBan || !canDelete) && (
        <a href={enableUrl} className="moderation-actions-btn enable-moderation">
          Enable moderation tools
        </a>
      )}
    </div>
  </div>
);

export default KickUserPanel;
